'use strict';

var $ = require('jquery');
require('gwwp');
require('./mobile-navigation.js');

$(function(){
});